var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container"},[_c('label',{staticClass:"label",attrs:{"for":_vm.componentID}},[_vm._v(_vm._s(_vm.labelText))]),_c('input',{staticClass:"input",attrs:{"type":"text","id":_vm.componentID}})])}
var staticRenderFns = []

export { render, staticRenderFns }